import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from "rxjs";

@Component({
    selector: 'db-hosting-domains',
    templateUrl: './hosting-domains.component.html',
    styleUrls: ['./hosting-domains.component.scss'],
    standalone: false
})
export class HostingDomainsComponent implements OnInit, OnDestroy {

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor() {
  }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
